import { orderConfirmationPageContainerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { css } from "styled-components";

Object.assign(orderConfirmationPageContainerStyles, {
    accountSignUpGridItem: {
        css: css`
            order: 2;
            padding:0 15px;
        `,
        width: 12,
    }
});
